import { BillingStatus } from '@40seas/entities/billings';
import { EnumColor } from '@40seas/frontend/common/providers';

export const billingStatusColorMapping: Record<BillingStatus, EnumColor> = {
    [BillingStatus.Pending]: 'warning',
    [BillingStatus.InProgress]: 'info',
    [BillingStatus.Done]: 'success',
    [BillingStatus.Failed]: 'error',
    [BillingStatus.Canceled]: 'error',
};
